module.exports = __webpack_public_path__ + "img/RENATO_GOMES.45ed14df.jpeg";